var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropDownMenu',{attrs:{"classNames":_vm.classNames,"closeOnItemClick":_vm.closeOnItemClick,"handleClickaway":_vm.handleClickaway,"isFilterDropDown":true,"isLargeDropDown":false,"menuSections":_vm.menuSections,"menuFontSize":"small","menuTitle":"filter by","refresh":_vm.refresh,"showMenuLabel":true,"storeModule":_vm.storeModule}})
}
var staticRenderFns = []

export { render, staticRenderFns }